import React, { FC } from 'react';

import clsx from 'clsx';

import { CategoryTreeRootItem } from '@domains/categories';

import { Picture } from '@components/common/Picture/Picture';
import { PlaceholderIcon } from '@components/icons/PlaceholderIcon';

import styles from './CategoryAccordion.module.scss';

type CategoryAccordionContentProps = Pick<CategoryTreeRootItem, 'thumbnail' | 'name'>;

export const CategoryAccordionContent: FC<CategoryAccordionContentProps> = (props) => {
    const { thumbnail, name } = props;
    return (
        <>
            {thumbnail ? (
                <Picture
                    sources={thumbnail}
                    className={styles.categoryImage}
                    classes={{ picture: styles.categoryPicture }}
                />
            ) : (
                <div className={clsx(styles.placeholder, styles.categoryPicture)}>
                    <PlaceholderIcon />
                </div>
            )}
            <span className={styles.categoryTitle}>{name}</span>
        </>
    );
};
